module.exports = ":host ::ng-deep .app-lang-switcher {\n    margin-top: 10px !important;\n}\n"